module.exports = __webpack_public_path__ + "img/search.ed02ac6d.svg";